<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre11" id="pgepubid00005">CONTENTS</h3>
<p class="calibre14"><a href="#/Text/Section0002#PREFACE">PREFACE</a><br class="calibre6"/>
<a href="#/Text/Section0004#I._JOHN_DRYDEN">I. JOHN DRYDEN</a><br class="calibre6"/>
<span href="#/Text/Section0005#II._THE_METAPHYSICAL_POETS" title="Link target outside of Sample">II. THE METAPHYSICAL POETS</span><br class="calibre6"/>
<span href="#/Text/Section0006#III._ANDREW_MARVELL" title="Link target outside of Sample">III. ANDREW MARVELL</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?47010a3d